import * as Common from '@/tenant/common';

export class Assembly extends Common.MasterBase{
  constructor(){
    super('Assembly');
    this.binders.commodity = new Common.ModelBinder(Common.Commodity);
    this.binders.sku = new Common.ModelBinder(Common.SKU);
    this.state = Common.MasterBaseStatus.NotPosted;
    this.workflowStateId = Common.MasterBaseStatus.NotPosted;
  }
  public id: number = 0;
  public commodityId: number = 0;
  public commodity: Common.Commodity  = null;
  public name: string = '';
  public skuId: number = 0;
  public sku: Common.SKU = null;

  // 予備項目
  public reserveText1: string  = '';
  public reserveText2: string  = '';
  public reserveText3: string  = '';
  public reserveText4: string  = '';
  public reserveText5: string  = '';
  public reserveText6: string  = '';
  public reserveMemo1: string  = '';
  public reserveMemo2: string  = '';
  public reserveMemo3: string  = '';
  public reserveDate1: Date  = null;
  public reserveDate2: Date  = null;
  public reserveDate3: Date  = null;
  public reserveList1: number  = null;
  public reserveList2: number  = null;
  public reserveList3: number  = null;

  public copy():any {
    const temp = super.copy() as Assembly;
    temp.id = 0;
    temp.state = Common.MasterBaseStatus.NotPosted;
    temp.workflowStateId = Common.MasterBaseStatus.NotPosted;
    return temp;
  }
}

export class AssemblyQuery extends Common.LoadQuery {
  constructor(){
    super('AssemblyQuery',Assembly);
    this.sort = 'name';
  }

  public commodityCode: string = '';
  public commodityName: string = '';  
  public commodity : Common.Commodity = null;
  public sku: Common.SKU = null;
  public name: string = '';
  public initialSavedOnFrom: Date = null;
  public initialSavedOnTo: Date = null;
  public lastUpdatedOnFrom: Date = null;
  public lastUpdatedOnTo: Date = null;
  public state: Common.MasterBaseStatus = null;
  public holder: string = '';
  public auditNo: string ='';
  public id :number = null;
}

export class AssemblyMasterQuery extends Common.LoadQuery {
  constructor(){
    super('AssemblyMasterQuery', Assembly);
  }
}
export class AssemblyChildItemQuery extends Common.Query {
  constructor(assembly: Common.Assembly){
    super('AssemblyChildItemQuery',new Common.ModelBinder(AssemblyChildItemResult,false)); 
    this.assembly = assembly;
  }
  public assembly : Common.Assembly;
}

export class AssemblyChildItemResult extends Common.ObjectBase {
    constructor(){
      super('AssemblyChildItemResult');
    }
    public hasComponentItems:boolean;
}